import React from "react";
import DSDialog from "./system-design/DSDialog";
import DSDialogTitle from "./system-design/DSDialogTitle";
import DSDialogContent from "./system-design/DSDialogContent";
import firebaseService from "../firebase_service/firebaseService";

export type KlydoFramesProps = {
  onHide: () => void;
  klydoLoopUrl: string;
};
const KlydoFrames = ({ onHide, klydoLoopUrl }: KlydoFramesProps) => {
  const [frames, setFrames] = React.useState<{ url: string; name: string }[]>(
    [],
  );
  const [downloadProgress, setDownloadProgress] = React.useState<number>(0);

  React.useEffect(() => {
    firebaseService.getKlydoFrames(
      klydoLoopUrl.split("/").pop()?.split(".")[0] as string,
      (frames) => setFrames(frames),
      (progress) => setDownloadProgress(progress),
    );
  }, [klydoLoopUrl]);

  return (
    <DSDialog open onClose={onHide} maxWidth="lg" fullWidth>
      <DSDialogTitle>Klydo Frames</DSDialogTitle>
      <DSDialogContent>
        {frames?.length ? (
          <div style={{ display: "flex", flexWrap: "wrap" }}>
            {frames.map((image, index) => (
              <a
                key={index}
                href={image.url}
                download={image.name}
                style={{ margin: "10px" }}
              >
                <img
                  src={image.url}
                  alt={`img-${index}`}
                  style={{ width: "200px" }}
                />
              </a>
            ))}
          </div>
        ) : (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              padding: "40px",
            }}
          >
            <div style={{ marginBottom: "20px" }}>
              Downloading frames... {downloadProgress}%
            </div>
            <div
              style={{
                width: "300px",
                height: "20px",
                backgroundColor: "#e0e0e0",
                borderRadius: "10px",
                overflow: "hidden",
              }}
            >
              <div
                style={{
                  width: `${downloadProgress}%`,
                  height: "100%",
                  backgroundColor: "#4caf50",
                  transition: "width 0.3s ease",
                }}
              />
            </div>
          </div>
        )}
      </DSDialogContent>
    </DSDialog>
  );
};
export default KlydoFrames;
